import styled, { css } from 'styled-components';
export const Button = styled.button `
  appearance: none;
  -webkit-appearance: none;
  background-color: transparent;
  border: none;
  opacity: .5;
  transition: all .2s linear;
  cursor: pointer;
  padding: 0 .6rem;
  
  ${({ isActive }) => isActive && css `
    opacity: 1;
  `}
`;
export const Heading = styled.span `
  background-color: transparent;
  border: none;
  margin-bottom: 1rem;
  display: block;
`;
export const Wrapper = styled.div `
  display: flex;
  justify-content: space-around;
  margin-bottom: 1rem;

  ${Heading},
  ${Button} {
    ${({ theme: { calendarHeading } }) => calendarHeading}
  }
`;
export default {
    Wrapper,
    Heading,
    Button,
};
